/* eslint-disable */
// @ts-nocheck
// 生成物。編集しない。元: schemas/progress-export.schema.json（node scripts/generate-validators.ts で再生成）

function ucs2length(str) {
  let length = 0;
  for (const _ of str) length++;
  return length;
}
function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (Array.isArray(a)) return a.length === b.length && a.every((x, i) => equal(x, b[i]));
    const ka = Object.keys(a);
    if (ka.length !== Object.keys(b).length) return false;
    return ka.every((k) => Object.prototype.hasOwnProperty.call(b, k) && equal(a[k], b[k]));
  }
  return a !== a && b !== b;
}

export const validateExport = validate52;
const schema19 = {
  $schema: 'https://json-schema.org/draft/2020-12/schema',
  $id: 'https://class.inductor.dev/schemas/progress-export.schema.json',
  type: 'object',
  required: ['format', 'version', 'exportedAt', 'progress', 'settings', 'drafts', 'lessons'],
  additionalProperties: false,
  properties: {
    format: { const: 'inductor-class-export' },
    version: { const: 2 },
    exportedAt: { type: 'string', format: 'date-time' },
    progress: { $ref: '#/$defs/progress' },
    settings: { $ref: '#/$defs/settings' },
    drafts: { $ref: '#/$defs/drafts' },
    lessons: { $ref: '#/$defs/lessonProgress' },
    problemDrafts: { type: 'object', additionalProperties: { type: 'string' } },
  },
  $defs: {
    date: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$' },
    cardId: { type: 'string', pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$', maxLength: 64 },
    lessonId: {
      type: 'string',
      pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*-[0-9]{2}-[a-z0-9]+(?:-[a-z0-9]+)*$',
      maxLength: 80,
    },
    blockId: { type: 'string', pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$', minLength: 3, maxLength: 40 },
    lessonRecord: {
      type: 'object',
      required: ['firstOpened', 'experiments', 'writes'],
      additionalProperties: false,
      properties: {
        firstOpened: { $ref: '#/$defs/date' },
        experiments: {
          type: 'array',
          maxItems: 50,
          uniqueItems: true,
          items: { $ref: '#/$defs/blockId' },
        },
        writes: {
          type: 'array',
          maxItems: 50,
          uniqueItems: true,
          items: { $ref: '#/$defs/blockId' },
        },
        completed: { $ref: '#/$defs/date' },
      },
    },
    lessonProgress: {
      type: 'object',
      required: ['version', 'lessons'],
      additionalProperties: false,
      properties: {
        version: { const: 1 },
        lessons: {
          type: 'object',
          maxProperties: 1000,
          propertyNames: { $ref: '#/$defs/lessonId' },
          additionalProperties: { $ref: '#/$defs/lessonRecord' },
        },
      },
    },
    cardRecord: {
      type: 'object',
      required: ['box', 'due', 'firstSeen', 'lastEvaluated', 'seen', 'correct'],
      additionalProperties: false,
      properties: {
        box: { type: 'integer', minimum: 1, maximum: 5 },
        due: { $ref: '#/$defs/date' },
        firstSeen: { $ref: '#/$defs/date' },
        lastEvaluated: { $ref: '#/$defs/date' },
        seen: { type: 'integer', minimum: 1 },
        correct: { type: 'integer', minimum: 0 },
      },
    },
    historyEntry: {
      type: 'object',
      required: ['at', 'date', 'cardId', 'result', 'hint', 'evaluated'],
      additionalProperties: false,
      properties: {
        at: { type: 'string', format: 'date-time' },
        date: { $ref: '#/$defs/date' },
        cardId: { $ref: '#/$defs/cardId' },
        result: { enum: ['correct', 'wrong'] },
        hint: { type: 'boolean' },
        evaluated: { type: 'boolean' },
        verdict: { enum: ['AC', 'WA', 'RE', 'TLE'] },
        preflightMatched: { type: 'boolean' },
      },
    },
    progress: {
      type: 'object',
      required: ['version', 'cards', 'activity', 'history'],
      additionalProperties: false,
      properties: {
        version: { const: 1 },
        cards: {
          type: 'object',
          propertyNames: { $ref: '#/$defs/cardId' },
          additionalProperties: { $ref: '#/$defs/cardRecord' },
        },
        activity: {
          type: 'object',
          propertyNames: { $ref: '#/$defs/date' },
          additionalProperties: { type: 'integer', minimum: 1 },
        },
        history: { type: 'array', maxItems: 2000, items: { $ref: '#/$defs/historyEntry' } },
      },
    },
    settings: {
      type: 'object',
      required: ['version'],
      additionalProperties: false,
      properties: {
        version: { const: 1 },
        dailyReviewLimit: { type: 'integer', minimum: 0, maximum: 200, default: 20 },
        dailyNewLimit: { type: 'integer', minimum: 0, maximum: 50, default: 5 },
        motion: { enum: ['system', 'reduce', 'full'], default: 'system' },
        lastExportAt: { type: 'string', format: 'date-time' },
      },
    },
    drafts: {
      type: 'object',
      required: ['version', 'items'],
      additionalProperties: false,
      properties: {
        version: { const: 1 },
        items: {
          type: 'object',
          maxProperties: 200,
          propertyNames: { $ref: '#/$defs/cardId' },
          additionalProperties: {
            type: 'object',
            required: ['code', 'updatedAt'],
            additionalProperties: false,
            properties: {
              code: { type: 'string', maxLength: 65536 },
              updatedAt: { type: 'string', format: 'date-time' },
            },
          },
        },
      },
    },
  },
};
const schema20 = {
  type: 'object',
  required: ['version', 'cards', 'activity', 'history'],
  additionalProperties: false,
  properties: {
    version: { const: 1 },
    cards: {
      type: 'object',
      propertyNames: { $ref: '#/$defs/cardId' },
      additionalProperties: { $ref: '#/$defs/cardRecord' },
    },
    activity: {
      type: 'object',
      propertyNames: { $ref: '#/$defs/date' },
      additionalProperties: { type: 'integer', minimum: 1 },
    },
    history: { type: 'array', maxItems: 2000, items: { $ref: '#/$defs/historyEntry' } },
  },
};
const schema21 = { type: 'string', pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$', maxLength: 64 };
const func1 = ucs2length;
const pattern3 = new RegExp('^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$', 'u');
function validate54(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate54.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 64) {
        validate54.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 64 },
            message: 'must NOT have more than 64 characters',
          },
        ];
        return false;
      } else {
        if (!pattern3.test(data)) {
          validate54.errors = [
            {
              instancePath,
              schemaPath: '#/pattern',
              keyword: 'pattern',
              params: { pattern: '^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$' },
              message: 'must match pattern "' + '^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$' + '"',
            },
          ];
          return false;
        }
      }
    } else {
      validate54.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
validate54.evaluated = { dynamicProps: false, dynamicItems: false };
const schema22 = {
  type: 'object',
  required: ['box', 'due', 'firstSeen', 'lastEvaluated', 'seen', 'correct'],
  additionalProperties: false,
  properties: {
    box: { type: 'integer', minimum: 1, maximum: 5 },
    due: { $ref: '#/$defs/date' },
    firstSeen: { $ref: '#/$defs/date' },
    lastEvaluated: { $ref: '#/$defs/date' },
    seen: { type: 'integer', minimum: 1 },
    correct: { type: 'integer', minimum: 0 },
  },
};
const schema23 = { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$' };
const pattern4 = new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}$', 'u');
function validate57(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate57.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (!pattern4.test(data)) {
        validate57.errors = [
          {
            instancePath,
            schemaPath: '#/pattern',
            keyword: 'pattern',
            params: { pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$' },
            message: 'must match pattern "' + '^[0-9]{4}-[0-9]{2}-[0-9]{2}$' + '"',
          },
        ];
        return false;
      }
    } else {
      validate57.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate57.errors = vErrors;
  return errors === 0;
}
validate57.evaluated = { dynamicProps: false, dynamicItems: false };
function validate56(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate56.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.box === undefined && (missing0 = 'box')) ||
        (data.due === undefined && (missing0 = 'due')) ||
        (data.firstSeen === undefined && (missing0 = 'firstSeen')) ||
        (data.lastEvaluated === undefined && (missing0 = 'lastEvaluated')) ||
        (data.seen === undefined && (missing0 = 'seen')) ||
        (data.correct === undefined && (missing0 = 'correct'))
      ) {
        validate56.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'box' ||
            key0 === 'due' ||
            key0 === 'firstSeen' ||
            key0 === 'lastEvaluated' ||
            key0 === 'seen' ||
            key0 === 'correct'
          )) {
            validate56.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.box !== undefined) {
            let data0 = data.box;
            const _errs2 = errors;
            if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
              validate56.errors = [
                {
                  instancePath: instancePath + '/box',
                  schemaPath: '#/properties/box/type',
                  keyword: 'type',
                  params: { type: 'integer' },
                  message: 'must be integer',
                },
              ];
              return false;
            }
            if (errors === _errs2) {
              if (typeof data0 == 'number') {
                if (data0 > 5 || isNaN(data0)) {
                  validate56.errors = [
                    {
                      instancePath: instancePath + '/box',
                      schemaPath: '#/properties/box/maximum',
                      keyword: 'maximum',
                      params: { comparison: '<=', limit: 5 },
                      message: 'must be <= 5',
                    },
                  ];
                  return false;
                } else {
                  if (data0 < 1 || isNaN(data0)) {
                    validate56.errors = [
                      {
                        instancePath: instancePath + '/box',
                        schemaPath: '#/properties/box/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 1 },
                        message: 'must be >= 1',
                      },
                    ];
                    return false;
                  }
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.due !== undefined) {
              const _errs4 = errors;
              if (
                !validate57(data.due, {
                  instancePath: instancePath + '/due',
                  parentData: data,
                  parentDataProperty: 'due',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.firstSeen !== undefined) {
                const _errs5 = errors;
                if (
                  !validate57(data.firstSeen, {
                    instancePath: instancePath + '/firstSeen',
                    parentData: data,
                    parentDataProperty: 'firstSeen',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.lastEvaluated !== undefined) {
                  const _errs6 = errors;
                  if (
                    !validate57(data.lastEvaluated, {
                      instancePath: instancePath + '/lastEvaluated',
                      parentData: data,
                      parentDataProperty: 'lastEvaluated',
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs6 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.seen !== undefined) {
                    let data4 = data.seen;
                    const _errs7 = errors;
                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                      validate56.errors = [
                        {
                          instancePath: instancePath + '/seen',
                          schemaPath: '#/properties/seen/type',
                          keyword: 'type',
                          params: { type: 'integer' },
                          message: 'must be integer',
                        },
                      ];
                      return false;
                    }
                    if (errors === _errs7) {
                      if (typeof data4 == 'number') {
                        if (data4 < 1 || isNaN(data4)) {
                          validate56.errors = [
                            {
                              instancePath: instancePath + '/seen',
                              schemaPath: '#/properties/seen/minimum',
                              keyword: 'minimum',
                              params: { comparison: '>=', limit: 1 },
                              message: 'must be >= 1',
                            },
                          ];
                          return false;
                        }
                      }
                    }
                    var valid0 = _errs7 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.correct !== undefined) {
                      let data5 = data.correct;
                      const _errs9 = errors;
                      if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                        validate56.errors = [
                          {
                            instancePath: instancePath + '/correct',
                            schemaPath: '#/properties/correct/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer',
                          },
                        ];
                        return false;
                      }
                      if (errors === _errs9) {
                        if (typeof data5 == 'number') {
                          if (data5 < 0 || isNaN(data5)) {
                            validate56.errors = [
                              {
                                instancePath: instancePath + '/correct',
                                schemaPath: '#/properties/correct/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0 },
                                message: 'must be >= 0',
                              },
                            ];
                            return false;
                          }
                        }
                      }
                      var valid0 = _errs9 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate56.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate56.errors = vErrors;
  return errors === 0;
}
validate56.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema24 = {
  type: 'object',
  required: ['at', 'date', 'cardId', 'result', 'hint', 'evaluated'],
  additionalProperties: false,
  properties: {
    at: { type: 'string', format: 'date-time' },
    date: { $ref: '#/$defs/date' },
    cardId: { $ref: '#/$defs/cardId' },
    result: { enum: ['correct', 'wrong'] },
    hint: { type: 'boolean' },
    evaluated: { type: 'boolean' },
    verdict: { enum: ['AC', 'WA', 'RE', 'TLE'] },
    preflightMatched: { type: 'boolean' },
  },
};
function validate63(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate63.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.at === undefined && (missing0 = 'at')) ||
        (data.date === undefined && (missing0 = 'date')) ||
        (data.cardId === undefined && (missing0 = 'cardId')) ||
        (data.result === undefined && (missing0 = 'result')) ||
        (data.hint === undefined && (missing0 = 'hint')) ||
        (data.evaluated === undefined && (missing0 = 'evaluated'))
      ) {
        validate63.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'at' ||
            key0 === 'date' ||
            key0 === 'cardId' ||
            key0 === 'result' ||
            key0 === 'hint' ||
            key0 === 'evaluated' ||
            key0 === 'verdict' ||
            key0 === 'preflightMatched'
          )) {
            validate63.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.at !== undefined) {
            const _errs2 = errors;
            if (errors === _errs2) {
              if (errors === _errs2) {
                if (!(typeof data.at === 'string')) {
                  validate63.errors = [
                    {
                      instancePath: instancePath + '/at',
                      schemaPath: '#/properties/at/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.date !== undefined) {
              const _errs4 = errors;
              if (
                !validate57(data.date, {
                  instancePath: instancePath + '/date',
                  parentData: data,
                  parentDataProperty: 'date',
                  rootData,
                  dynamicAnchors,
                })
              ) {
                vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                errors = vErrors.length;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.cardId !== undefined) {
                const _errs5 = errors;
                if (
                  !validate54(data.cardId, {
                    instancePath: instancePath + '/cardId',
                    parentData: data,
                    parentDataProperty: 'cardId',
                    rootData,
                    dynamicAnchors,
                  })
                ) {
                  vErrors =
                    vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.result !== undefined) {
                  let data3 = data.result;
                  const _errs6 = errors;
                  if (!(data3 === 'correct' || data3 === 'wrong')) {
                    validate63.errors = [
                      {
                        instancePath: instancePath + '/result',
                        schemaPath: '#/properties/result/enum',
                        keyword: 'enum',
                        params: { allowedValues: schema24.properties.result.enum },
                        message: 'must be equal to one of the allowed values',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs6 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hint !== undefined) {
                    const _errs7 = errors;
                    if (typeof data.hint !== 'boolean') {
                      validate63.errors = [
                        {
                          instancePath: instancePath + '/hint',
                          schemaPath: '#/properties/hint/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs7 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.evaluated !== undefined) {
                      const _errs9 = errors;
                      if (typeof data.evaluated !== 'boolean') {
                        validate63.errors = [
                          {
                            instancePath: instancePath + '/evaluated',
                            schemaPath: '#/properties/evaluated/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs9 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.verdict !== undefined) {
                        let data6 = data.verdict;
                        const _errs11 = errors;
                        if (!(
                          data6 === 'AC' ||
                          data6 === 'WA' ||
                          data6 === 'RE' ||
                          data6 === 'TLE'
                        )) {
                          validate63.errors = [
                            {
                              instancePath: instancePath + '/verdict',
                              schemaPath: '#/properties/verdict/enum',
                              keyword: 'enum',
                              params: { allowedValues: schema24.properties.verdict.enum },
                              message: 'must be equal to one of the allowed values',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs11 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.preflightMatched !== undefined) {
                          const _errs12 = errors;
                          if (typeof data.preflightMatched !== 'boolean') {
                            validate63.errors = [
                              {
                                instancePath: instancePath + '/preflightMatched',
                                schemaPath: '#/properties/preflightMatched/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs12 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate63.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate63.errors = vErrors;
  return errors === 0;
}
validate63.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate53(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate53.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.cards === undefined && (missing0 = 'cards')) ||
        (data.activity === undefined && (missing0 = 'activity')) ||
        (data.history === undefined && (missing0 = 'history'))
      ) {
        validate53.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'version' ||
            key0 === 'cards' ||
            key0 === 'activity' ||
            key0 === 'history'
          )) {
            validate53.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate53.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cards !== undefined) {
              let data1 = data.cards;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  for (const key1 in data1) {
                    const _errs5 = errors;
                    if (
                      !validate54(key1, {
                        instancePath: instancePath + '/cards',
                        parentData: data1,
                        parentDataProperty: 'cards',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs5 === errors;
                    if (!valid1) {
                      const err0 = {
                        instancePath: instancePath + '/cards',
                        schemaPath: '#/properties/cards/propertyNames',
                        keyword: 'propertyNames',
                        params: { propertyName: key1 },
                        message: 'property name must be valid',
                      };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                      validate53.errors = vErrors;
                      return false;
                      break;
                    }
                  }
                  if (valid1) {
                    for (const key2 in data1) {
                      const _errs7 = errors;
                      if (
                        !validate56(data1[key2], {
                          instancePath:
                            instancePath +
                            '/cards/' +
                            key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                          parentData: data1,
                          parentDataProperty: key2,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
                        errors = vErrors.length;
                      }
                      var valid2 = _errs7 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  }
                } else {
                  validate53.errors = [
                    {
                      instancePath: instancePath + '/cards',
                      schemaPath: '#/properties/cards/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.activity !== undefined) {
                let data3 = data.activity;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                    for (const key3 in data3) {
                      const _errs10 = errors;
                      if (
                        !validate57(key3, {
                          instancePath: instancePath + '/activity',
                          parentData: data3,
                          parentDataProperty: 'activity',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                        errors = vErrors.length;
                      }
                      var valid3 = _errs10 === errors;
                      if (!valid3) {
                        const err1 = {
                          instancePath: instancePath + '/activity',
                          schemaPath: '#/properties/activity/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key3 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                        validate53.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid3) {
                      for (const key4 in data3) {
                        let data4 = data3[key4];
                        const _errs12 = errors;
                        if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                          validate53.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/activity/' +
                                key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                              schemaPath: '#/properties/activity/additionalProperties/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        if (errors === _errs12) {
                          if (typeof data4 == 'number') {
                            if (data4 < 1 || isNaN(data4)) {
                              validate53.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/activity/' +
                                    key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                                  schemaPath: '#/properties/activity/additionalProperties/minimum',
                                  keyword: 'minimum',
                                  params: { comparison: '>=', limit: 1 },
                                  message: 'must be >= 1',
                                },
                              ];
                              return false;
                            }
                          }
                        }
                        var valid4 = _errs12 === errors;
                        if (!valid4) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate53.errors = [
                      {
                        instancePath: instancePath + '/activity',
                        schemaPath: '#/properties/activity/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.history !== undefined) {
                  let data5 = data.history;
                  const _errs14 = errors;
                  if (errors === _errs14) {
                    if (Array.isArray(data5)) {
                      if (data5.length > 2000) {
                        validate53.errors = [
                          {
                            instancePath: instancePath + '/history',
                            schemaPath: '#/properties/history/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 2000 },
                            message: 'must NOT have more than 2000 items',
                          },
                        ];
                        return false;
                      } else {
                        var valid5 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs16 = errors;
                          if (
                            !validate63(data5[i0], {
                              instancePath: instancePath + '/history/' + i0,
                              parentData: data5,
                              parentDataProperty: i0,
                              rootData,
                              dynamicAnchors,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate63.errors
                                : vErrors.concat(validate63.errors);
                            errors = vErrors.length;
                          }
                          var valid5 = _errs16 === errors;
                          if (!valid5) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate53.errors = [
                        {
                          instancePath: instancePath + '/history',
                          schemaPath: '#/properties/history/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate53.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
validate53.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema25 = {
  type: 'object',
  required: ['version'],
  additionalProperties: false,
  properties: {
    version: { const: 1 },
    dailyReviewLimit: { type: 'integer', minimum: 0, maximum: 200, default: 20 },
    dailyNewLimit: { type: 'integer', minimum: 0, maximum: 50, default: 5 },
    motion: { enum: ['system', 'reduce', 'full'], default: 'system' },
    lastExportAt: { type: 'string', format: 'date-time' },
  },
};
function validate68(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate68.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.version === undefined && (missing0 = 'version')) {
        validate68.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'version' ||
            key0 === 'dailyReviewLimit' ||
            key0 === 'dailyNewLimit' ||
            key0 === 'motion' ||
            key0 === 'lastExportAt'
          )) {
            validate68.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate68.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.dailyReviewLimit !== undefined) {
              let data1 = data.dailyReviewLimit;
              const _errs3 = errors;
              if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                validate68.errors = [
                  {
                    instancePath: instancePath + '/dailyReviewLimit',
                    schemaPath: '#/properties/dailyReviewLimit/type',
                    keyword: 'type',
                    params: { type: 'integer' },
                    message: 'must be integer',
                  },
                ];
                return false;
              }
              if (errors === _errs3) {
                if (typeof data1 == 'number') {
                  if (data1 > 200 || isNaN(data1)) {
                    validate68.errors = [
                      {
                        instancePath: instancePath + '/dailyReviewLimit',
                        schemaPath: '#/properties/dailyReviewLimit/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 200 },
                        message: 'must be <= 200',
                      },
                    ];
                    return false;
                  } else {
                    if (data1 < 0 || isNaN(data1)) {
                      validate68.errors = [
                        {
                          instancePath: instancePath + '/dailyReviewLimit',
                          schemaPath: '#/properties/dailyReviewLimit/minimum',
                          keyword: 'minimum',
                          params: { comparison: '>=', limit: 0 },
                          message: 'must be >= 0',
                        },
                      ];
                      return false;
                    }
                  }
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.dailyNewLimit !== undefined) {
                let data2 = data.dailyNewLimit;
                const _errs5 = errors;
                if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                  validate68.errors = [
                    {
                      instancePath: instancePath + '/dailyNewLimit',
                      schemaPath: '#/properties/dailyNewLimit/type',
                      keyword: 'type',
                      params: { type: 'integer' },
                      message: 'must be integer',
                    },
                  ];
                  return false;
                }
                if (errors === _errs5) {
                  if (typeof data2 == 'number') {
                    if (data2 > 50 || isNaN(data2)) {
                      validate68.errors = [
                        {
                          instancePath: instancePath + '/dailyNewLimit',
                          schemaPath: '#/properties/dailyNewLimit/maximum',
                          keyword: 'maximum',
                          params: { comparison: '<=', limit: 50 },
                          message: 'must be <= 50',
                        },
                      ];
                      return false;
                    } else {
                      if (data2 < 0 || isNaN(data2)) {
                        validate68.errors = [
                          {
                            instancePath: instancePath + '/dailyNewLimit',
                            schemaPath: '#/properties/dailyNewLimit/minimum',
                            keyword: 'minimum',
                            params: { comparison: '>=', limit: 0 },
                            message: 'must be >= 0',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.motion !== undefined) {
                  let data3 = data.motion;
                  const _errs7 = errors;
                  if (!(data3 === 'system' || data3 === 'reduce' || data3 === 'full')) {
                    validate68.errors = [
                      {
                        instancePath: instancePath + '/motion',
                        schemaPath: '#/properties/motion/enum',
                        keyword: 'enum',
                        params: { allowedValues: schema25.properties.motion.enum },
                        message: 'must be equal to one of the allowed values',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.lastExportAt !== undefined) {
                    const _errs8 = errors;
                    if (errors === _errs8) {
                      if (errors === _errs8) {
                        if (!(typeof data.lastExportAt === 'string')) {
                          validate68.errors = [
                            {
                              instancePath: instancePath + '/lastExportAt',
                              schemaPath: '#/properties/lastExportAt/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                      }
                    }
                    var valid0 = _errs8 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate68.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate68.errors = vErrors;
  return errors === 0;
}
validate68.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema26 = {
  type: 'object',
  required: ['version', 'items'],
  additionalProperties: false,
  properties: {
    version: { const: 1 },
    items: {
      type: 'object',
      maxProperties: 200,
      propertyNames: { $ref: '#/$defs/cardId' },
      additionalProperties: {
        type: 'object',
        required: ['code', 'updatedAt'],
        additionalProperties: false,
        properties: {
          code: { type: 'string', maxLength: 65536 },
          updatedAt: { type: 'string', format: 'date-time' },
        },
      },
    },
  },
};
function validate70(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate70.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.items === undefined && (missing0 = 'items'))
      ) {
        validate70.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'version' || key0 === 'items')) {
            validate70.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate70.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.items !== undefined) {
              let data1 = data.items;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  if (Object.keys(data1).length > 200) {
                    validate70.errors = [
                      {
                        instancePath: instancePath + '/items',
                        schemaPath: '#/properties/items/maxProperties',
                        keyword: 'maxProperties',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 properties',
                      },
                    ];
                    return false;
                  } else {
                    for (const key1 in data1) {
                      const _errs5 = errors;
                      if (
                        !validate54(key1, {
                          instancePath: instancePath + '/items',
                          parentData: data1,
                          parentDataProperty: 'items',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        const err0 = {
                          instancePath: instancePath + '/items',
                          schemaPath: '#/properties/items/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate70.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data1) {
                        let data2 = data1[key2];
                        const _errs7 = errors;
                        if (errors === _errs7) {
                          if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                            let missing1;
                            if (
                              (data2.code === undefined && (missing1 = 'code')) ||
                              (data2.updatedAt === undefined && (missing1 = 'updatedAt'))
                            ) {
                              validate70.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/items/' +
                                    key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                  schemaPath: '#/properties/items/additionalProperties/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message: "must have required property '" + missing1 + "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs9 = errors;
                              for (const key3 in data2) {
                                if (!(key3 === 'code' || key3 === 'updatedAt')) {
                                  validate70.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/items/' +
                                        key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                      schemaPath:
                                        '#/properties/items/additionalProperties/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key3 },
                                      message: 'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs9 === errors) {
                                if (data2.code !== undefined) {
                                  let data3 = data2.code;
                                  const _errs10 = errors;
                                  if (errors === _errs10) {
                                    if (typeof data3 === 'string') {
                                      if (func1(data3) > 65536) {
                                        validate70.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/items/' +
                                              key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                              '/code',
                                            schemaPath:
                                              '#/properties/items/additionalProperties/properties/code/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 65536 },
                                            message: 'must NOT have more than 65536 characters',
                                          },
                                        ];
                                        return false;
                                      }
                                    } else {
                                      validate70.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/items/' +
                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                            '/code',
                                          schemaPath:
                                            '#/properties/items/additionalProperties/properties/code/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid3 = _errs10 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data2.updatedAt !== undefined) {
                                    const _errs12 = errors;
                                    if (errors === _errs12) {
                                      if (errors === _errs12) {
                                        if (!(typeof data2.updatedAt === 'string')) {
                                          validate70.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/items/' +
                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                '/updatedAt',
                                              schemaPath:
                                                '#/properties/items/additionalProperties/properties/updatedAt/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                    }
                                    var valid3 = _errs12 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate70.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/items/' +
                                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                schemaPath: '#/properties/items/additionalProperties/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate70.errors = [
                    {
                      instancePath: instancePath + '/items',
                      schemaPath: '#/properties/items/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate70.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate70.errors = vErrors;
  return errors === 0;
}
validate70.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
const schema27 = {
  type: 'object',
  required: ['version', 'lessons'],
  additionalProperties: false,
  properties: {
    version: { const: 1 },
    lessons: {
      type: 'object',
      maxProperties: 1000,
      propertyNames: { $ref: '#/$defs/lessonId' },
      additionalProperties: { $ref: '#/$defs/lessonRecord' },
    },
  },
};
const schema28 = {
  type: 'string',
  pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*-[0-9]{2}-[a-z0-9]+(?:-[a-z0-9]+)*$',
  maxLength: 80,
};
const pattern5 = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*-[0-9]{2}-[a-z0-9]+(?:-[a-z0-9]+)*$', 'u');
function validate74(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate74.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 80) {
        validate74.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 80 },
            message: 'must NOT have more than 80 characters',
          },
        ];
        return false;
      } else {
        if (!pattern5.test(data)) {
          validate74.errors = [
            {
              instancePath,
              schemaPath: '#/pattern',
              keyword: 'pattern',
              params: { pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*-[0-9]{2}-[a-z0-9]+(?:-[a-z0-9]+)*$' },
              message:
                'must match pattern "' +
                '^[a-z0-9]+(?:-[a-z0-9]+)*-[0-9]{2}-[a-z0-9]+(?:-[a-z0-9]+)*$' +
                '"',
            },
          ];
          return false;
        }
      }
    } else {
      validate74.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
validate74.evaluated = { dynamicProps: false, dynamicItems: false };
const schema29 = {
  type: 'object',
  required: ['firstOpened', 'experiments', 'writes'],
  additionalProperties: false,
  properties: {
    firstOpened: { $ref: '#/$defs/date' },
    experiments: {
      type: 'array',
      maxItems: 50,
      uniqueItems: true,
      items: { $ref: '#/$defs/blockId' },
    },
    writes: { type: 'array', maxItems: 50, uniqueItems: true, items: { $ref: '#/$defs/blockId' } },
    completed: { $ref: '#/$defs/date' },
  },
};
const schema30 = {
  type: 'string',
  pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$',
  minLength: 3,
  maxLength: 40,
};
const pattern6 = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$', 'u');
function validate78(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate78.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (typeof data === 'string') {
      if (func1(data) > 40) {
        validate78.errors = [
          {
            instancePath,
            schemaPath: '#/maxLength',
            keyword: 'maxLength',
            params: { limit: 40 },
            message: 'must NOT have more than 40 characters',
          },
        ];
        return false;
      } else {
        if (func1(data) < 3) {
          validate78.errors = [
            {
              instancePath,
              schemaPath: '#/minLength',
              keyword: 'minLength',
              params: { limit: 3 },
              message: 'must NOT have fewer than 3 characters',
            },
          ];
          return false;
        } else {
          if (!pattern6.test(data)) {
            validate78.errors = [
              {
                instancePath,
                schemaPath: '#/pattern',
                keyword: 'pattern',
                params: { pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$' },
                message: 'must match pattern "' + '^[a-z0-9]+(?:-[a-z0-9]+)*$' + '"',
              },
            ];
            return false;
          }
        }
      }
    } else {
      validate78.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        },
      ];
      return false;
    }
  }
  validate78.errors = vErrors;
  return errors === 0;
}
validate78.evaluated = { dynamicProps: false, dynamicItems: false };
const func0 = equal;
function validate76(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate76.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.firstOpened === undefined && (missing0 = 'firstOpened')) ||
        (data.experiments === undefined && (missing0 = 'experiments')) ||
        (data.writes === undefined && (missing0 = 'writes'))
      ) {
        validate76.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'firstOpened' ||
            key0 === 'experiments' ||
            key0 === 'writes' ||
            key0 === 'completed'
          )) {
            validate76.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.firstOpened !== undefined) {
            const _errs2 = errors;
            if (
              !validate57(data.firstOpened, {
                instancePath: instancePath + '/firstOpened',
                parentData: data,
                parentDataProperty: 'firstOpened',
                rootData,
                dynamicAnchors,
              })
            ) {
              vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.experiments !== undefined) {
              let data1 = data.experiments;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (Array.isArray(data1)) {
                  if (data1.length > 50) {
                    validate76.errors = [
                      {
                        instancePath: instancePath + '/experiments',
                        schemaPath: '#/properties/experiments/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 50 },
                        message: 'must NOT have more than 50 items',
                      },
                    ];
                    return false;
                  } else {
                    var valid1 = true;
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs5 = errors;
                      if (
                        !validate78(data1[i0], {
                          instancePath: instancePath + '/experiments/' + i0,
                          parentData: data1,
                          parentDataProperty: i0,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate78.errors : vErrors.concat(validate78.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        break;
                      }
                    }
                    if (valid1) {
                      let i1 = data1.length;
                      let j0;
                      if (i1 > 1) {
                        outer0: for (; i1--;) {
                          for (j0 = i1; j0--;) {
                            if (func0(data1[i1], data1[j0])) {
                              validate76.errors = [
                                {
                                  instancePath: instancePath + '/experiments',
                                  schemaPath: '#/properties/experiments/uniqueItems',
                                  keyword: 'uniqueItems',
                                  params: { i: i1, j: j0 },
                                  message:
                                    'must NOT have duplicate items (items ## ' +
                                    j0 +
                                    ' and ' +
                                    i1 +
                                    ' are identical)',
                                },
                              ];
                              return false;
                              break outer0;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate76.errors = [
                    {
                      instancePath: instancePath + '/experiments',
                      schemaPath: '#/properties/experiments/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.writes !== undefined) {
                let data3 = data.writes;
                const _errs6 = errors;
                if (errors === _errs6) {
                  if (Array.isArray(data3)) {
                    if (data3.length > 50) {
                      validate76.errors = [
                        {
                          instancePath: instancePath + '/writes',
                          schemaPath: '#/properties/writes/maxItems',
                          keyword: 'maxItems',
                          params: { limit: 50 },
                          message: 'must NOT have more than 50 items',
                        },
                      ];
                      return false;
                    } else {
                      var valid3 = true;
                      const len1 = data3.length;
                      for (let i2 = 0; i2 < len1; i2++) {
                        const _errs8 = errors;
                        if (
                          !validate78(data3[i2], {
                            instancePath: instancePath + '/writes/' + i2,
                            parentData: data3,
                            parentDataProperty: i2,
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate78.errors
                              : vErrors.concat(validate78.errors);
                          errors = vErrors.length;
                        }
                        var valid3 = _errs8 === errors;
                        if (!valid3) {
                          break;
                        }
                      }
                      if (valid3) {
                        let i3 = data3.length;
                        let j1;
                        if (i3 > 1) {
                          outer1: for (; i3--;) {
                            for (j1 = i3; j1--;) {
                              if (func0(data3[i3], data3[j1])) {
                                validate76.errors = [
                                  {
                                    instancePath: instancePath + '/writes',
                                    schemaPath: '#/properties/writes/uniqueItems',
                                    keyword: 'uniqueItems',
                                    params: { i: i3, j: j1 },
                                    message:
                                      'must NOT have duplicate items (items ## ' +
                                      j1 +
                                      ' and ' +
                                      i3 +
                                      ' are identical)',
                                  },
                                ];
                                return false;
                                break outer1;
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    validate76.errors = [
                      {
                        instancePath: instancePath + '/writes',
                        schemaPath: '#/properties/writes/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.completed !== undefined) {
                  const _errs9 = errors;
                  if (
                    !validate57(data.completed, {
                      instancePath: instancePath + '/completed',
                      parentData: data,
                      parentDataProperty: 'completed',
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate76.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate76.errors = vErrors;
  return errors === 0;
}
validate76.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate73(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate73.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.lessons === undefined && (missing0 = 'lessons'))
      ) {
        validate73.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'version' || key0 === 'lessons')) {
            validate73.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate73.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.lessons !== undefined) {
              let data1 = data.lessons;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  if (Object.keys(data1).length > 1000) {
                    validate73.errors = [
                      {
                        instancePath: instancePath + '/lessons',
                        schemaPath: '#/properties/lessons/maxProperties',
                        keyword: 'maxProperties',
                        params: { limit: 1000 },
                        message: 'must NOT have more than 1000 properties',
                      },
                    ];
                    return false;
                  } else {
                    for (const key1 in data1) {
                      const _errs5 = errors;
                      if (
                        !validate74(key1, {
                          instancePath: instancePath + '/lessons',
                          parentData: data1,
                          parentDataProperty: 'lessons',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        const err0 = {
                          instancePath: instancePath + '/lessons',
                          schemaPath: '#/properties/lessons/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate73.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data1) {
                        const _errs7 = errors;
                        if (
                          !validate76(data1[key2], {
                            instancePath:
                              instancePath +
                              '/lessons/' +
                              key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                            parentData: data1,
                            parentDataProperty: key2,
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate76.errors
                              : vErrors.concat(validate76.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate73.errors = [
                    {
                      instancePath: instancePath + '/lessons',
                      schemaPath: '#/properties/lessons/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate73.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate73.errors = vErrors;
  return errors === 0;
}
validate73.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
function validate52(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  /*# sourceURL="https://class.inductor.dev/schemas/progress-export.schema.json" */ let vErrors =
    null;
  let errors = 0;
  const evaluated0 = validate52.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.format === undefined && (missing0 = 'format')) ||
        (data.version === undefined && (missing0 = 'version')) ||
        (data.exportedAt === undefined && (missing0 = 'exportedAt')) ||
        (data.progress === undefined && (missing0 = 'progress')) ||
        (data.settings === undefined && (missing0 = 'settings')) ||
        (data.drafts === undefined && (missing0 = 'drafts')) ||
        (data.lessons === undefined && (missing0 = 'lessons'))
      ) {
        validate52.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'format' ||
            key0 === 'version' ||
            key0 === 'exportedAt' ||
            key0 === 'progress' ||
            key0 === 'settings' ||
            key0 === 'drafts' ||
            key0 === 'lessons' ||
            key0 === 'problemDrafts'
          )) {
            validate52.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.format !== undefined) {
            const _errs2 = errors;
            if ('inductor-class-export' !== data.format) {
              validate52.errors = [
                {
                  instancePath: instancePath + '/format',
                  schemaPath: '#/properties/format/const',
                  keyword: 'const',
                  params: { allowedValue: 'inductor-class-export' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.version !== undefined) {
              const _errs3 = errors;
              if (2 !== data.version) {
                validate52.errors = [
                  {
                    instancePath: instancePath + '/version',
                    schemaPath: '#/properties/version/const',
                    keyword: 'const',
                    params: { allowedValue: 2 },
                    message: 'must be equal to constant',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.exportedAt !== undefined) {
                const _errs4 = errors;
                if (errors === _errs4) {
                  if (errors === _errs4) {
                    if (!(typeof data.exportedAt === 'string')) {
                      validate52.errors = [
                        {
                          instancePath: instancePath + '/exportedAt',
                          schemaPath: '#/properties/exportedAt/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                  }
                }
                var valid0 = _errs4 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.progress !== undefined) {
                  const _errs6 = errors;
                  if (
                    !validate53(data.progress, {
                      instancePath: instancePath + '/progress',
                      parentData: data,
                      parentDataProperty: 'progress',
                      rootData,
                      dynamicAnchors,
                    })
                  ) {
                    vErrors =
                      vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs6 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.settings !== undefined) {
                    const _errs7 = errors;
                    if (
                      !validate68(data.settings, {
                        instancePath: instancePath + '/settings',
                        parentData: data,
                        parentDataProperty: 'settings',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs7 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.drafts !== undefined) {
                      const _errs8 = errors;
                      if (
                        !validate70(data.drafts, {
                          instancePath: instancePath + '/drafts',
                          parentData: data,
                          parentDataProperty: 'drafts',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate70.errors : vErrors.concat(validate70.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs8 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.lessons !== undefined) {
                        const _errs9 = errors;
                        if (
                          !validate73(data.lessons, {
                            instancePath: instancePath + '/lessons',
                            parentData: data,
                            parentDataProperty: 'lessons',
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate73.errors
                              : vErrors.concat(validate73.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs9 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.problemDrafts !== undefined) {
                          let data7 = data.problemDrafts;
                          const _errs10 = errors;
                          if (errors === _errs10) {
                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                              for (const key1 in data7) {
                                const _errs13 = errors;
                                if (typeof data7[key1] !== 'string') {
                                  validate52.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/problemDrafts/' +
                                        key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                      schemaPath:
                                        '#/properties/problemDrafts/additionalProperties/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs13 === errors;
                                if (!valid1) {
                                  break;
                                }
                              }
                            } else {
                              validate52.errors = [
                                {
                                  instancePath: instancePath + '/problemDrafts',
                                  schemaPath: '#/properties/problemDrafts/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs10 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate52.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
validate52.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateProgress = validate84;
function validate84(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate84.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.cards === undefined && (missing0 = 'cards')) ||
        (data.activity === undefined && (missing0 = 'activity')) ||
        (data.history === undefined && (missing0 = 'history'))
      ) {
        validate84.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'version' ||
            key0 === 'cards' ||
            key0 === 'activity' ||
            key0 === 'history'
          )) {
            validate84.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate84.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.cards !== undefined) {
              let data1 = data.cards;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  for (const key1 in data1) {
                    const _errs5 = errors;
                    if (
                      !validate54(key1, {
                        instancePath: instancePath + '/cards',
                        parentData: data1,
                        parentDataProperty: 'cards',
                        rootData,
                        dynamicAnchors,
                      })
                    ) {
                      vErrors =
                        vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                      errors = vErrors.length;
                    }
                    var valid1 = _errs5 === errors;
                    if (!valid1) {
                      const err0 = {
                        instancePath: instancePath + '/cards',
                        schemaPath: '#/properties/cards/propertyNames',
                        keyword: 'propertyNames',
                        params: { propertyName: key1 },
                        message: 'property name must be valid',
                      };
                      if (vErrors === null) {
                        vErrors = [err0];
                      } else {
                        vErrors.push(err0);
                      }
                      errors++;
                      validate84.errors = vErrors;
                      return false;
                      break;
                    }
                  }
                  if (valid1) {
                    for (const key2 in data1) {
                      const _errs7 = errors;
                      if (
                        !validate56(data1[key2], {
                          instancePath:
                            instancePath +
                            '/cards/' +
                            key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                          parentData: data1,
                          parentDataProperty: key2,
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
                        errors = vErrors.length;
                      }
                      var valid2 = _errs7 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  }
                } else {
                  validate84.errors = [
                    {
                      instancePath: instancePath + '/cards',
                      schemaPath: '#/properties/cards/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.activity !== undefined) {
                let data3 = data.activity;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                    for (const key3 in data3) {
                      const _errs10 = errors;
                      if (
                        !validate57(key3, {
                          instancePath: instancePath + '/activity',
                          parentData: data3,
                          parentDataProperty: 'activity',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                        errors = vErrors.length;
                      }
                      var valid3 = _errs10 === errors;
                      if (!valid3) {
                        const err1 = {
                          instancePath: instancePath + '/activity',
                          schemaPath: '#/properties/activity/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key3 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err1];
                        } else {
                          vErrors.push(err1);
                        }
                        errors++;
                        validate84.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid3) {
                      for (const key4 in data3) {
                        let data4 = data3[key4];
                        const _errs12 = errors;
                        if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                          validate84.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/activity/' +
                                key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                              schemaPath: '#/properties/activity/additionalProperties/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        if (errors === _errs12) {
                          if (typeof data4 == 'number') {
                            if (data4 < 1 || isNaN(data4)) {
                              validate84.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/activity/' +
                                    key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                                  schemaPath: '#/properties/activity/additionalProperties/minimum',
                                  keyword: 'minimum',
                                  params: { comparison: '>=', limit: 1 },
                                  message: 'must be >= 1',
                                },
                              ];
                              return false;
                            }
                          }
                        }
                        var valid4 = _errs12 === errors;
                        if (!valid4) {
                          break;
                        }
                      }
                    }
                  } else {
                    validate84.errors = [
                      {
                        instancePath: instancePath + '/activity',
                        schemaPath: '#/properties/activity/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.history !== undefined) {
                  let data5 = data.history;
                  const _errs14 = errors;
                  if (errors === _errs14) {
                    if (Array.isArray(data5)) {
                      if (data5.length > 2000) {
                        validate84.errors = [
                          {
                            instancePath: instancePath + '/history',
                            schemaPath: '#/properties/history/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 2000 },
                            message: 'must NOT have more than 2000 items',
                          },
                        ];
                        return false;
                      } else {
                        var valid5 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs16 = errors;
                          if (
                            !validate63(data5[i0], {
                              instancePath: instancePath + '/history/' + i0,
                              parentData: data5,
                              parentDataProperty: i0,
                              rootData,
                              dynamicAnchors,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate63.errors
                                : vErrors.concat(validate63.errors);
                            errors = vErrors.length;
                          }
                          var valid5 = _errs16 === errors;
                          if (!valid5) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate84.errors = [
                        {
                          instancePath: instancePath + '/history',
                          schemaPath: '#/properties/history/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs14 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate84.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate84.errors = vErrors;
  return errors === 0;
}
validate84.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateSettings = validate89;
function validate89(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate89.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.version === undefined && (missing0 = 'version')) {
        validate89.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(
            key0 === 'version' ||
            key0 === 'dailyReviewLimit' ||
            key0 === 'dailyNewLimit' ||
            key0 === 'motion' ||
            key0 === 'lastExportAt'
          )) {
            validate89.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate89.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.dailyReviewLimit !== undefined) {
              let data1 = data.dailyReviewLimit;
              const _errs3 = errors;
              if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                validate89.errors = [
                  {
                    instancePath: instancePath + '/dailyReviewLimit',
                    schemaPath: '#/properties/dailyReviewLimit/type',
                    keyword: 'type',
                    params: { type: 'integer' },
                    message: 'must be integer',
                  },
                ];
                return false;
              }
              if (errors === _errs3) {
                if (typeof data1 == 'number') {
                  if (data1 > 200 || isNaN(data1)) {
                    validate89.errors = [
                      {
                        instancePath: instancePath + '/dailyReviewLimit',
                        schemaPath: '#/properties/dailyReviewLimit/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 200 },
                        message: 'must be <= 200',
                      },
                    ];
                    return false;
                  } else {
                    if (data1 < 0 || isNaN(data1)) {
                      validate89.errors = [
                        {
                          instancePath: instancePath + '/dailyReviewLimit',
                          schemaPath: '#/properties/dailyReviewLimit/minimum',
                          keyword: 'minimum',
                          params: { comparison: '>=', limit: 0 },
                          message: 'must be >= 0',
                        },
                      ];
                      return false;
                    }
                  }
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.dailyNewLimit !== undefined) {
                let data2 = data.dailyNewLimit;
                const _errs5 = errors;
                if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                  validate89.errors = [
                    {
                      instancePath: instancePath + '/dailyNewLimit',
                      schemaPath: '#/properties/dailyNewLimit/type',
                      keyword: 'type',
                      params: { type: 'integer' },
                      message: 'must be integer',
                    },
                  ];
                  return false;
                }
                if (errors === _errs5) {
                  if (typeof data2 == 'number') {
                    if (data2 > 50 || isNaN(data2)) {
                      validate89.errors = [
                        {
                          instancePath: instancePath + '/dailyNewLimit',
                          schemaPath: '#/properties/dailyNewLimit/maximum',
                          keyword: 'maximum',
                          params: { comparison: '<=', limit: 50 },
                          message: 'must be <= 50',
                        },
                      ];
                      return false;
                    } else {
                      if (data2 < 0 || isNaN(data2)) {
                        validate89.errors = [
                          {
                            instancePath: instancePath + '/dailyNewLimit',
                            schemaPath: '#/properties/dailyNewLimit/minimum',
                            keyword: 'minimum',
                            params: { comparison: '>=', limit: 0 },
                            message: 'must be >= 0',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.motion !== undefined) {
                  let data3 = data.motion;
                  const _errs7 = errors;
                  if (!(data3 === 'system' || data3 === 'reduce' || data3 === 'full')) {
                    validate89.errors = [
                      {
                        instancePath: instancePath + '/motion',
                        schemaPath: '#/properties/motion/enum',
                        keyword: 'enum',
                        params: { allowedValues: schema25.properties.motion.enum },
                        message: 'must be equal to one of the allowed values',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.lastExportAt !== undefined) {
                    const _errs8 = errors;
                    if (errors === _errs8) {
                      if (errors === _errs8) {
                        if (!(typeof data.lastExportAt === 'string')) {
                          validate89.errors = [
                            {
                              instancePath: instancePath + '/lastExportAt',
                              schemaPath: '#/properties/lastExportAt/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                      }
                    }
                    var valid0 = _errs8 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate89.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate89.errors = vErrors;
  return errors === 0;
}
validate89.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateDrafts = validate90;
function validate90(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate90.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.items === undefined && (missing0 = 'items'))
      ) {
        validate90.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'version' || key0 === 'items')) {
            validate90.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate90.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.items !== undefined) {
              let data1 = data.items;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  if (Object.keys(data1).length > 200) {
                    validate90.errors = [
                      {
                        instancePath: instancePath + '/items',
                        schemaPath: '#/properties/items/maxProperties',
                        keyword: 'maxProperties',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 properties',
                      },
                    ];
                    return false;
                  } else {
                    for (const key1 in data1) {
                      const _errs5 = errors;
                      if (
                        !validate54(key1, {
                          instancePath: instancePath + '/items',
                          parentData: data1,
                          parentDataProperty: 'items',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        const err0 = {
                          instancePath: instancePath + '/items',
                          schemaPath: '#/properties/items/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate90.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data1) {
                        let data2 = data1[key2];
                        const _errs7 = errors;
                        if (errors === _errs7) {
                          if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                            let missing1;
                            if (
                              (data2.code === undefined && (missing1 = 'code')) ||
                              (data2.updatedAt === undefined && (missing1 = 'updatedAt'))
                            ) {
                              validate90.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/items/' +
                                    key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                  schemaPath: '#/properties/items/additionalProperties/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message: "must have required property '" + missing1 + "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs9 = errors;
                              for (const key3 in data2) {
                                if (!(key3 === 'code' || key3 === 'updatedAt')) {
                                  validate90.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/items/' +
                                        key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                      schemaPath:
                                        '#/properties/items/additionalProperties/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key3 },
                                      message: 'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs9 === errors) {
                                if (data2.code !== undefined) {
                                  let data3 = data2.code;
                                  const _errs10 = errors;
                                  if (errors === _errs10) {
                                    if (typeof data3 === 'string') {
                                      if (func1(data3) > 65536) {
                                        validate90.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/items/' +
                                              key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                              '/code',
                                            schemaPath:
                                              '#/properties/items/additionalProperties/properties/code/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 65536 },
                                            message: 'must NOT have more than 65536 characters',
                                          },
                                        ];
                                        return false;
                                      }
                                    } else {
                                      validate90.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/items/' +
                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                            '/code',
                                          schemaPath:
                                            '#/properties/items/additionalProperties/properties/code/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid3 = _errs10 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data2.updatedAt !== undefined) {
                                    const _errs12 = errors;
                                    if (errors === _errs12) {
                                      if (errors === _errs12) {
                                        if (!(typeof data2.updatedAt === 'string')) {
                                          validate90.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/items/' +
                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                '/updatedAt',
                                              schemaPath:
                                                '#/properties/items/additionalProperties/properties/updatedAt/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                    }
                                    var valid3 = _errs12 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                }
                              }
                            }
                          } else {
                            validate90.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/items/' +
                                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                schemaPath: '#/properties/items/additionalProperties/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate90.errors = [
                    {
                      instancePath: instancePath + '/items',
                      schemaPath: '#/properties/items/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate90.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate90.errors = vErrors;
  return errors === 0;
}
validate90.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
export const validateLessonProgress = validate92;
function validate92(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data, dynamicAnchors = {} } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate92.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.version === undefined && (missing0 = 'version')) ||
        (data.lessons === undefined && (missing0 = 'lessons'))
      ) {
        validate92.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'version' || key0 === 'lessons')) {
            validate92.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.version !== undefined) {
            const _errs2 = errors;
            if (1 !== data.version) {
              validate92.errors = [
                {
                  instancePath: instancePath + '/version',
                  schemaPath: '#/properties/version/const',
                  keyword: 'const',
                  params: { allowedValue: 1 },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.lessons !== undefined) {
              let data1 = data.lessons;
              const _errs3 = errors;
              if (errors === _errs3) {
                if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                  if (Object.keys(data1).length > 1000) {
                    validate92.errors = [
                      {
                        instancePath: instancePath + '/lessons',
                        schemaPath: '#/properties/lessons/maxProperties',
                        keyword: 'maxProperties',
                        params: { limit: 1000 },
                        message: 'must NOT have more than 1000 properties',
                      },
                    ];
                    return false;
                  } else {
                    for (const key1 in data1) {
                      const _errs5 = errors;
                      if (
                        !validate74(key1, {
                          instancePath: instancePath + '/lessons',
                          parentData: data1,
                          parentDataProperty: 'lessons',
                          rootData,
                          dynamicAnchors,
                        })
                      ) {
                        vErrors =
                          vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
                        errors = vErrors.length;
                      }
                      var valid1 = _errs5 === errors;
                      if (!valid1) {
                        const err0 = {
                          instancePath: instancePath + '/lessons',
                          schemaPath: '#/properties/lessons/propertyNames',
                          keyword: 'propertyNames',
                          params: { propertyName: key1 },
                          message: 'property name must be valid',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate92.errors = vErrors;
                        return false;
                        break;
                      }
                    }
                    if (valid1) {
                      for (const key2 in data1) {
                        const _errs7 = errors;
                        if (
                          !validate76(data1[key2], {
                            instancePath:
                              instancePath +
                              '/lessons/' +
                              key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                            parentData: data1,
                            parentDataProperty: key2,
                            rootData,
                            dynamicAnchors,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate76.errors
                              : vErrors.concat(validate76.errors);
                          errors = vErrors.length;
                        }
                        var valid2 = _errs7 === errors;
                        if (!valid2) {
                          break;
                        }
                      }
                    }
                  }
                } else {
                  validate92.errors = [
                    {
                      instancePath: instancePath + '/lessons',
                      schemaPath: '#/properties/lessons/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate92.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate92.errors = vErrors;
  return errors === 0;
}
validate92.evaluated = { props: true, dynamicProps: false, dynamicItems: false };
